import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import PageHero from "../components/site/PageHero";
import { PageSection, NumberSteps, CTABand, DisclaimerBox } from "../components/site/ContentBlocks";
import { PATIENT_JOURNEY, HEALTHCARE_DISCLAIMER } from "../data/content";

export default function PatientJourney() {
    return (
        <div className="grain bg-navy-deep" data-testid="patient-journey-page">
            <Header />
            <main>
                <PageHero
                    seo={{
                        title: "How the Patient Journey Works | Viet Medica Ltd",
                        description:
                            "From your first enquiry to provider-led aftercare — the eight coordinated steps of an international patient journey with Viet Medica Ltd.",
                        path: "/patient-journey",
                    }}
                    crumbs={[{ label: "Healthcare & Medical Tourism", href: "/healthcare-medical-tourism" }, { label: "Patient Journey" }]}
                    eyebrow="Healthcare & Medical Tourism"
                    title="How the Patient"
                    titleEm="Journey Works."
                    copy="Every patient's situation is different, but the shape of a well-coordinated journey is consistent. These are the steps we guide you through, from first contact to provider-led follow-up."
                />

                <PageSection testid="patient-journey-steps">
                    <NumberSteps steps={PATIENT_JOURNEY} />
                    <div className="mt-10">
                        <DisclaimerBox text={HEALTHCARE_DISCLAIMER} testid="journey-disclaimer" />
                    </div>
                </PageSection>

                <section className="bg-navy-surface py-20 lg:py-28">
                    <div className="mx-auto max-w-[1440px] px-5 lg:px-10">
                        <CTABand
                            title="Start with a simple conversation."
                            primary={{ label: "Healthcare Enquiry", to: "/healthcare-enquiry", testid: "journey-enquiry-cta" }}
                            secondary={{ label: "Explore Destinations", to: "/healthcare-medical-tourism", testid: "journey-destinations-cta" }}
                        />
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
